import { createSelector } from '@ngrx/store';
import { getSharedFeatureState, SharedState } from '../reducers';

const getAccessorialRequestState = createSelector(getSharedFeatureState, (state: SharedState) => state.accessorialRequestState);

export const getUnlockSaving = createSelector(getAccessorialRequestState, (state) => state.saving);
